import { GET_LANGUAGES } from "../actions/languages";

const INITIAL_STATE = {
  list: [],
  isFetching: false,
  isFetched: false,
  isError: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_LANGUAGES.REQUEST: {
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        isError: false
      };
    }
    case GET_LANGUAGES.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isError: false,
        list: action.payload
      };
    }
    case GET_LANGUAGES.ERROR: {
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        isError: true
      };
    }

    default:
      return state;
  }
}
